module.exports = __webpack_public_path__ + "img/product-ketang-nsxl-05.82a65cfd.png";